// Restricted (c) Siemens Healthineers AG, 2025, All rights reserved.

import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { map } from 'rxjs';
import { DNA_MODALITY_ID } from 'src/app/modules/shared/utils/modalityHelpers';
import { APICallGateComponent } from '../../../shared/components/api-call-gate.component';
import { SystemOverviewService } from '../../services/systemOverview.service';
import { SystemOverviewDefaultComponent } from '../system-overview-default/system-overview-default.component';
import { SystemOverviewSyngoviaComponent } from '../system-overview-syngovia/system-overview-syngovia.component';

@Component({
  standalone: true,
  selector: 'app-system-overview-switch',
  templateUrl: './system-overview-switch.component.html',
  styleUrls: ['./system-overview-switch.component.scss'],
  imports: [
    CommonModule,
    APICallGateComponent,
    SystemOverviewSyngoviaComponent,
    SystemOverviewDefaultComponent,
  ],
})
export class SystemOverviewSwitchComponent {
  protected readonly DNA_MODALITY_ID = DNA_MODALITY_ID;

  protected readonly systemDetails = this.systemOverviewService.systemDetails;
  protected readonly lastSuccessfulData$ =
    this.systemDetails.lastSuccessfulData$;

  protected readonly modalityId$ = this.lastSuccessfulData$.pipe(
    map(({ modalityId }) => modalityId)
  );

  public constructor(
    private readonly systemOverviewService: SystemOverviewService
  ) {}
}
